// Supported browsers are defined in .browserslistrc; IE-only polyfills are no longer needed.
import '@angular/localize/init';
import 'zone.js';

// Retained for legacy browser dependencies that access the global alias.
(window as any).global = window;
